import { makeVar } from '@apollo/client';

export const isIncomeSchemaEditableVar = makeVar(null);

export const negotiationLimitsInAbsoluteValuesVar = makeVar(null);

export const selectedSchemaDetailIdVar = makeVar(null);
